import { render, staticRenderFns } from "./HistoryTwoInOne2.vue?vue&type=template&id=628f2889&scoped=true"
import script from "./HistoryTwoInOne2.vue?vue&type=script&lang=js"
export * from "./HistoryTwoInOne2.vue?vue&type=script&lang=js"
import style0 from "./HistoryTwoInOne2.vue?vue&type=style&index=0&id=628f2889&prod&lang=less&scoped=true"
import style1 from "./HistoryTwoInOne2.vue?vue&type=style&index=1&id=628f2889&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628f2889",
  null
  
)

export default component.exports